import { render, staticRenderFns } from "./TitleList.vue?vue&type=template&id=2c4a7da9"
import script from "./TitleList.vue?vue&type=script&setup=true&lang=js"
export * from "./TitleList.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports